import mask from 'jquery-mask-plugin';

export default function myMask() {
  $(document).ready(function () {
    var options = {
      onKeyPress: function (cpfcnpj, e, field, options) {
        var masks = ['000.000.000-000999', '00.000.000/0000-00'];
        var mask = (cpfcnpj.length > 14) ? masks[1] : masks[0];
        $('[name="document"]').mask(mask, options);
      }
    };
    $('[name="document"]').mask('00.000.000/0000-00', options);
    $('[name="cep"]').mask('00000-000');
    $('[name="phone"]').mask('(00) 00000-0000');
    $('[name="cnpj"]').mask('00.000.000/0000-00');
    $('[name="nota_fiscal"]').mask('0000000');
    $("#inputCpf").mask('000.000.000-00');
  });

  $('.languages-select').change(function (event) {
    if ($(this).val()) {
      window.location.href = $(this).val();
    }
  });
}